/* Pure cart checks, independent of the storefront UI. All prices are Shopify cents. */
(function (host) {
  const gifted = item => Boolean(item.properties && item.properties._Gifted);
  function giftStatus(cart, config) {
    if (!config.required || cart.currency !== 'EUR') return {ready:true, pending:[], qualifying:0};
    const qualifying = cart.items.filter(i=>!gifted(i)).reduce((n,i)=>n+i.original_line_price,0);
    const pending=[];
    for (const rule of config.rules) {
      const matches=cart.items.filter(i => gifted(i) &&
        (rule.productId ? String(i.product_id)===String(rule.productId) :
          i.sku===rule.sku || i.properties._Gifted===rule.name));
      const count=matches.reduce((n,i)=>n+i.quantity,0);
      if(qualifying>=rule.threshold){
        if(count!==rule.quantity || matches.some(i=>i.final_line_price!==0)) pending.push(rule.label);
      } else if(count>0) pending.push(rule.label);
    }
    return {ready:pending.length===0,pending,qualifying};
  }
  function cartSignature(cart) {
    return JSON.stringify([cart.currency,cart.total_price,cart.items.map(i=>[i.key,i.quantity,i.final_line_price,i.discounts])]);
  }
  function visibleProperties(item){return Object.entries(item.properties||{}).filter(([k,v])=>!k.startsWith('_')&&v!==''&&v!==null);}
  function propertiesFor(fields,values){const out={};for(const f of fields){const v=String(values[f.key]||'').trim();if(f.required&&!v)throw Error('Bitte '+f.key+' ausfüllen.');out[f.key]=v;}return out;}
  function validQuantity(value){return Number.isInteger(value)&&value>=1&&value<=99;}
  const api={gifted,giftStatus,cartSignature,visibleProperties,propertiesFor,validQuantity};
  if(typeof module!=='undefined'&&module.exports)module.exports=api; else host.KMSaleCore=Object.freeze(api);
})(typeof window==='undefined'?globalThis:window);
